export interface BrandEquityNarrative {
  why: string
  where: string
  who: string
  competitor: string
  what_next: string
  expected_impact: string
  _fallback?: boolean
  _message?: string
}

export interface BrandEquityReport {
  dbei_score: number
  brand_status: string
  calculation_date: string
  previous_dbei_score: number | null
  score_change: number | null
  data_coverage_pct: number
  pillars: Record<string, PillarData>
  metrics: MetricData[]
  unavailable_metrics: UnavailableMetric[]
  narrative?: BrandEquityNarrative
}

export interface PillarData {
  label: string
  weight: number
  score: number
  channels?: Record<string, ChannelData>
}

export interface ChannelData {
  label: string
  weight: number
  score: number
  available_submetrics: number
  total_submetrics: number
}

export interface MetricData {
  pillar: string
  metric_key: string
  raw_value: number | null
  normalized_score: number
  data_quality: 'actual' | 'approximate' | 'unavailable'
}

export interface UnavailableMetric {
  metric_key: string
  pillar: string
  notes: string
}

export interface BrandEquityConfig {
  metrics: ConfigMetric[]
}

export interface ConfigMetric {
  pillar: string
  metric_key: string
  label: string
  unit: string
  normalization_method: string
  weight?: number
}

export const PILLAR_META: Record<string, { label: string; icon: string; color: string }> = {
  CP: { label: 'Competitive Positioning', icon: 'ri-focus-3-line', color: '#5C4FCF' },
  CE: { label: 'Consumer Engagement', icon: 'ri-heart-pulse-line', color: '#00adc4' },
  CS: { label: 'Channel Strength', icon: 'ri-links-line', color: '#28a745' },
  OM: { label: 'Owned Media Strength', icon: 'ri-megaphone-line', color: '#ffc107' },
  TA: { label: 'Trust & Advocacy', icon: 'ri-shield-star-line', color: '#fd7e14' },
}

export const STATUS_COLORS: Record<string, string> = {
  'Market Leader': '#28a745',
  'Strong Brand': '#00adc4',
  'Developing Brand': '#ffc107',
  'Vulnerable Brand': '#fd7e14',
  'At Risk': '#dc3545',
}

export const PILLAR_ORDER = ['CP', 'CE', 'CS', 'OM', 'TA']
